import { PolygraphyProductUrlType } from '../../../../../../../services/exports/Constants';

export default {
  form: {
    url_type: {
      options: {
        [PolygraphyProductUrlType.OnlineShop]: 'Magazin online',
        [PolygraphyProductUrlType.Storefront]: 'Vitrină',
        [PolygraphyProductUrlType.Custom]: 'Personalizat',
      },
    },
  },
  labels: {
    save_changes_to_see_preview: 'Salvează modificările pentru a vedea previzualizarea',
  },
  buttons: {
    save_and_preview: 'Salvează și previzualizează',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea produsului',
    failed_to_save_changes: 'Eroare la salvarea modificărilor!',
    changes_got_saved: 'Modificările au fost salvate!',
  },
};
